module.exports = __webpack_public_path__ + "static/media/39239.fb3d3f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ourStaff/39239.png
// module id = 1424
// module chunks = 0